/* import __COLOCATED_TEMPLATE__ from './company-name-filter.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();